import { render, staticRenderFns } from "./ViewNumberZone.vue?vue&type=template&id=3a8cbda8&scoped=true"
import script from "./ViewNumberZone.vue?vue&type=script&lang=js"
export * from "./ViewNumberZone.vue?vue&type=script&lang=js"
import style0 from "./ViewNumberZone.vue?vue&type=style&index=0&id=3a8cbda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cbda8",
  null
  
)

export default component.exports